import { useCallback, useState } from 'react';
import { consumeDeepLink, peekDeepLink } from './deepLinkStore';

/**
 * Lee y consume un deep link pendiente en la página destino.
 * Usar el action registrado en DEEP_LINK_ACTIONS.
 */
const useDeepLinkAction = action => {
  const [pending, setPending] = useState(() => {
    const current = peekDeepLink();
    return current && current.action === action ? current : null;
  });

  const consume = useCallback(() => {
    consumeDeepLink(action);
    setPending(null);
  }, [action]);

  return {
    isPending: Boolean(pending),
    payload: pending ? pending.payload : null,
    consume,
  };
};

export default useDeepLinkAction;
